import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { SliceZone } from '@prismicio/react'

import { Community } from 'components/Community'
import { IMarkupSchemas } from 'components/SEOMarkupSchema'
import { components } from 'slices'

import { CommunitypostDocument, PageDocument } from 'types/prismic'
import { getEnv } from 'utils/env/env.util'
import { getFullPageByUID, getPrismicLangCode } from 'utils/prismic'
import { createClient } from 'env/prismicio'

const { baseUrl } = getEnv()
export type CommunityPosts = {
  page: number
  results_per_page: number
  total_results_size: number
  results_size: number
  total_pages: number
  results: CommunitypostDocument<string>[]
}

const CommunityPage = (props: {
  page: PageDocument<string>
  communityPosts: CommunityPosts
  locale: string
}) => (
  <>
    <SliceZone slices={props.page.data.slices} components={components} />
    <Community communityPosts={props.communityPosts} key={props.locale} />
  </>
)

export const getStaticProps: GetStaticProps = async ({
  locale: currentLocale,
  defaultLocale,
  previewData
}) => {
  const locale = currentLocale ?? defaultLocale ?? 'en'
  const client = createClient({ previewData })
  const pagePartsPromise = getFullPageByUID(
    'page',
    'community',
    { locale },
    { previewData }
  )

  const communityPostsPromise = client.getByType('communitypost', {
    lang: getPrismicLangCode(locale),
    pageSize: 18,
    orderings: [
      { field: 'my.communitypost.publishDate', direction: 'desc' },
      { field: 'document.first_publication_date', direction: 'desc' }
    ]
  })

  const i18nPromise = serverSideTranslations(locale, [
    'actions',
    'inputs',
    'community',
    'crm'
  ])

  const [pageParts, i18n, communityPosts] = await Promise.all([
    pagePartsPromise,
    i18nPromise,
    communityPostsPromise
  ])
  const { page, ...layoutParts } = pageParts
  const [seo] = page?.data?.seo ?? []

  const markupSchema: IMarkupSchemas = [
    {
      type: 'BreadcrumbList',
      data: {
        items: [{ name: 'Home', item: baseUrl }, { name: 'Expert Insights' }]
      }
    }
  ]
  return {
    props: {
      ...i18n,
      page,
      communityPosts,
      locale,
      seo: seo?.primary ?? null,
      internal: {
        layout: layoutParts
      },
      markupSchema
    },
    revalidate: 60 * 60 * 1
  }
}

export default CommunityPage
